import { useMutation } from 'react-query';
import axios from 'utilities/axios';

const API = {
  LOGIN: 'users/login',
  GET_ESTIMATOR: 'master/estimator-tool',
  GET_PROTECTED_ESTIMATOR: '/master/protected/estimator-tool',
  LOGOUT: 'users/logout',
  LOGIN_WITH_GOOGLE: 'users/login-with-google',
};

export const useLogin = () => {
  return useMutation(
    (values) =>
      axios
        .post(API.LOGIN, {
          ...values,
        })
        .then((res) => res.data),
    {
      onError: () => {},
    }
  );
};

export const useGetEstimator = () => {
  return useMutation((values) =>
    axios.post(API.GET_ESTIMATOR, values).then((res) => res.data)
  );
};

export const useGetProtectedEstimator = () => {
  return useMutation((values) =>
    axios.post(API.GET_PROTECTED_ESTIMATOR, values).then((res) => res.data)
  );
};

export const useLogout = () => {
  return useMutation(
    ({ token }) =>
      axios.post(
        API.LOGOUT,
        {},
        {
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
          },
        }
      ),
    {
      onSuccess: (_, { onCallback }) => {
        onCallback();
      },
    }
  );
};

export const useLoginWithGoogle = () => {
  return useMutation(
    (token) =>
      axios
        .post(API.LOGIN_WITH_GOOGLE, {
          token,
          systemType: 'Customer',
        })
        .then((res) => res.data),
    {
      onError: () => {},
    }
  );
};